const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = React.PropTypes;
const classNames = require('classnames');
const PopoverBase = require('./popover-base.react');
const SpringsMixin = require('../mixins/springs');
const SpringClickGroup = require('./spring-click-group.react');

const PopoverMenu = React.createClass({

  propTypes: {
    title: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      handler: PropTypes.func.isRequired,
      modifiers: PropTypes.arrayOf(PropTypes.string),
    })).isRequired,
    target: PropTypes.element.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    divider: PropTypes.number,
    heading: PropTypes.string,
  },

  mixins: [SpringsMixin(), PureRenderMixin],

  render() {
    const actionsDisplay = this.props.actions.map((action, i) => {

      const iconClasses = `PopoverMenu-icon icon icon-${ action.icon }`;

      const divider = this.props.divider === i ? <hr className="PopoverMenu-divider" /> : null;

      const onClick = () => {
        action.handler();
        this.props.onToggle();
      };

      const actionModifiers = action.modifiers || [];
      const actionClassNames = classNames(
        'PopoverMenu-action',
        ...actionModifiers.map(m => `PopoverMenu-action--${ m }`)
      );
      return (
        <div key={ `${ action.key }Container` } className="PopoverMenu-actionContainer">
          <SpringClickGroup context={ this } fullScale={ 1 } depressedScale={ 0.9 }>
            <a key={ action.key } className={ actionClassNames } onClick={ onClick }>
              <i className={ iconClasses }></i>
              { action.label }
            </a>
          </SpringClickGroup>
          { divider }
        </div>
      );
    });

    let conditionalHeading;
    if (this.props.heading) {
      conditionalHeading = <h1 className="PopoverMenu-heading">{ this.props.heading }</h1>;
    }

    return (
      <PopoverBase { ...this.props }>
        <div className="Popover-content">
          { conditionalHeading }
          { actionsDisplay }
        </div>
      </PopoverBase>
    );
  },

});

module.exports = PopoverMenu;
